import ASegmentItem from './SegmentItem.vue';
export default ASegmentItem;


// WEBPACK FOOTER //
// ./src/packages/SegmentItem/index.js